import * as React from "react";
import {observer} from "mobx-react";

import "./layer-list-list.scss";

import {LayerListItem} from "./layer-list-item/layer-list-item";
import {LayerListConfiguration} from "../../../config/layer-list-configuration";
import {SyntheticEvent} from "react";
import {SidebarControlsConfiguration} from "../../../../config/sidebar-configuration";
import ListItem from "@arcgis/core/widgets/LayerList/ListItem";
import {IAppStore, withStore} from "../../../stores/abstract-app-store";

export interface LayerListListProps {
    listItems: ListItem[];
    isRoot: boolean; // the root list
    level: number;
    onListItemClick: (event: SyntheticEvent, data: object, item: ListItem) => any;
    config: LayerListConfiguration;
    controlsConfig: SidebarControlsConfiguration;
    small?: boolean;
    store?: IAppStore;
}

@observer
class LayerListListBase extends React.Component<LayerListListProps, any> {
    constructor(props: LayerListListProps) {
        super(props);
    }

    render(): JSX.Element | JSX.Element[] {
        const {listItems} = this.props;
        const {onListItemClick, config, controlsConfig, level, isRoot, small}
            = this.props;
        const showElement = (controlsConfig.layerList.startLevel <= level);
        const listElements = listItems.map((oi: ListItem, index: number) =>
            <LayerListItem key={oi.layer.id || "listitem-" + index}
                data={oi}
                subitems={oi.children}
                isRoot={isRoot}
                level={level}
                onClick={onListItemClick}
                metadata={config.metadata}
                config={config}
                small={small as boolean}
                controlsConfig={controlsConfig} />
        );
        if (showElement) {
            return (
                <ul className={`layer-list ${isRoot ? "list-root" : "list-layer-root"}`}>
                    {listElements}
                </ul>
            );
        } else {
            return listElements;
        }

    }

    componentDidMount(): void {
    }

}

export const LayerListList = withStore(LayerListListBase);
